// Auto-generated build version — updated by post-build.cjs
export const BUILD_VERSION = "28.05.2026, 18:39:39";
export const BUILD_TIMESTAMP = "2026-05-28T15:39:39.883Z";
